<template>
    <!-- 学员管理 -->
    <div id="student">
        <el-tabs
            type="card"
            @tab-click="setIndex"
        >
            <el-tab-pane label="我的订单">
                <el-row :gutter="20">
                    <el-radio-group
                        v-model="orderForm.payStatus"
                        @change="changeorders"
                    >
                        <el-radio-button label="1">未缴费订单</el-radio-button>
                        <el-radio-button label="2">已缴费订单</el-radio-button>
                    </el-radio-group>
                </el-row>
                <div v-if="!showflag">
                    <div
                        class="order-title"
                        v-for="(item, index) in RecordData"
                        :key="index"
                    >
                        订单号:{{ item.order.orderNo }}

                        <el-table
                            :data="item.orderClassStudents"
                            ref="CourseData"
                            tooltip-effect="dark"
                            style="width: 100%"
                            v-loading="loading"
                            element-loading-text="数据加载中，请稍等..."
                            element-loading-spinner="el-icon-loading"
                            element-loading-background="rgba(0, 0, 0, 0.8)"
                        >
                            <el-table-column
                                prop="className"
                                label="班级"
                                min-width="120"
                            >
                                <template slot-scope="scope">
                                    <span style="font-size: 16px">{{
                                        scope.row.className
                                    }}</span><span
                                        v-if="scope.row.isShortTraining"
                                        style="color: #e4393c; font-size: 14px"
                                    >(短训班)</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="periodName"
                                label="上课教室时间"
                                min-width="160px"
                            >
                                <template slot-scope="scope">
                                    <span v-if="scope.row.isShortTraining">
                                        <el-tooltip
                                            :content="
                                                scope.row.$customClassName
                                            "
                                            placement="right"
                                        >
                                            <span>{{
                                                    scope.row
                                                        .shortTrainingStart
                                                }}到{{
                                                    scope.row.shortTrainingEnd
                                                }}</span>
                                        </el-tooltip>
                                    </span>
                                    <span v-else>{{
                                        scope.row.$customClassName
                                    }}</span>
                                </template>
                            </el-table-column>
                            <!-- <el-table-column prop="classRoomName" label="教室" show-overflow-tooltip></el-table-column> -->
                            <el-table-column
                                prop="teacherName"
                                label="教师"
                                show-overflow-tooltip
                            ></el-table-column>
                            <el-table-column
                                prop="fee"
                                label="学费/元"
                                show-overflow-tooltip
                            ></el-table-column>
                            <el-table-column
                                prop="materialCost"
                                label="材料费/元"
                                show-overflow-tooltip
                                v-if="item.mast"
                            ></el-table-column>
                            <el-table-column
                                prop="allClassFee"
                                label="报名费/元"
                                show-overflow-tooltip
                                v-if="item.isbm"
                            ></el-table-column>
                            <el-table-column
                                prop="ageRemissionMoney"
                                label="年龄折扣/元"
                                show-overflow-tooltip
                                v-if="item.agediscount"
                            >
                                <template slot-scope="scope">
                                    <span v-if="!scope.row.ageRemissionMoney">
                                        0
                                    </span>
                                    <span v-else>
                                        {{ scope.row.ageRemissionMoney }}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="identityRemission"
                                label="特殊身份减免/元"
                                show-overflow-tooltip
                                v-if="item.isspecial"
                            ></el-table-column>
                            <el-table-column
                                prop="traFee"
                                label="转班/元"
                                align="center"
                                show-overflow-tooltip
                                v-if="item.transfer"
                            >
                            </el-table-column>

                            <el-table-column
                                prop="subtotal"
                                label="小计/元"
                                show-overflow-tooltip
                            ></el-table-column>
                            <el-table-column
                                prop="reductionMoney"
                                label="学期优惠/元"
                                show-overflow-tooltip
                                v-if="item.reductionFlag"
                            ></el-table-column>
                            <el-table-column
                                prop="susFee"
                                label="休学抵消/元"
                                show-overflow-tooltip
                                v-if="item.isxx"
                            ></el-table-column>
                            <el-table-column
                                prop="totalAmount"
                                label="班级实收金额/元"
                                show-overflow-tooltip
                            ></el-table-column>
                        </el-table>
                        <div class="order-info">
                            <div>
                                创建时间：{{ item.order.gmtCreate | formatDate }}
                                <div v-if="item.order.payTime">
                                    付款时间：{{ item.order.payTime | formatDate }}
                                </div>
                            </div>

                            <div class="f-footer">
                                <div>
                                    <span>合计:</span>
                                    <span class="total">￥{{ item.order.amount }}</span>
                                </div>
                                <el-button
                                    v-if="item.order.payStatus == '1'"
                                    @click="cancel(index)"
                                >取消订单</el-button>
                                <el-button
                                    type="warning"
                                    @click="paynow(index)"
                                    style="float: right"
                                    v-if="item.order.payStatus == '1'"
                                >立即缴费</el-button>
                                <el-button
                                    style="float: right"
                                    v-if="item.order.payStatus == '2' && item.order.payType == '4'"
                                    @click="checkBoshInvoice(item.order.id)"
                                >查看票据</el-button>
                            </div>
                        </div>
                    </div>
                    <div
                        class="wrap_footer clearfix"
                        style="padding-bottom: 20px"
                    >
                        <div class="right">
                            <el-pagination
                                background
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="orderForm.pageIndex"
                                :page-sizes="[5, 10, 15, 20]"
                                :page-size="orderForm.pageSize"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="total"
                            >
                            </el-pagination>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <el-table
                        :data="RecordData"
                        ref="CourseData"
                        tooltip-effect="dark"
                        style="width: 100%"
                        v-loading="loading"
                        element-loading-text="数据加载中，请稍等..."
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(0, 0, 0, 0.8)"
                    >
                        <el-table-column
                            prop="courseName"
                            label="班级"
                            fixed="left"
                            show-overflow-tooltip
                            min-width="50"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="periodName"
                            label="上课时间"
                            show-overflow-tooltip
                        ></el-table-column>
                        <el-table-column
                            prop="classRoomName"
                            label="教室"
                            show-overflow-tooltip
                        ></el-table-column>
                        <el-table-column
                            prop="teacherName"
                            label="教师"
                            show-overflow-tooltip
                        ></el-table-column>
                        <el-table-column
                            prop="fee"
                            label="学费/元"
                            show-overflow-tooltip
                        ></el-table-column>
                        <el-table-column
                            prop="materialCost"
                            label="材料费/元"
                            show-overflow-tooltip
                        ></el-table-column>
                        <el-table-column
                            prop="receive"
                            label="报名费/元"
                            show-overflow-tooltip
                        ></el-table-column>

                        <el-table-column
                            prop="type"
                            label="缴费状态"
                            show-overflow-tooltip
                        >
                            <template slot-scope="scope">
                                <span v-if="scope.row.affirmed == '1'">已缴费</span>
                                <span v-if="scope.row.affirmed == '0'">未缴费</span>
                                <span v-if="scope.row.affirmed == '2'">无需缴费</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="type"
                            label="操作"
                            show-overflow-tooltip
                        >
                            <template slot-scope="scope">
                                <el-button
                                    @click="gopay(scope.row)"
                                    type="warning"
                                    v-if="scope.row.affirmed == '0'"
                                >前去缴费</el-button>
                                <el-button
                                    @click="
                                        showdetails('classmembers', scope.row)
                                    "
                                    v-else
                                >查看教学计划</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
export default {
    name: "myclass",

    data() {
        return {
            query: {
                type: "",
            },
            showflag: true,
            total: null,
            orderForm: {
                termId: "",
                payStatus: 1,
                startTime: "",
                endTime: "",
                pageIndex: 1,
                pageSize: 5,
            },
            agediscount: false,
            mainData: [],
            classdata: [],
            tabindex: "0",
            RecordData: [],
            reductionFlag: false,
            loading: "",
            totalfee: "",
        };
    },
    created() {
        this.$global.activeMenu = "2-4"; //不激活左侧
    },
    async mounted() {
        let me = this;

        if (this.$route.query.param) {
            this.orderForm.payStatus = 2;
        }
        await me.queryOrder();
    },
    filters: {
        formatDate: function (value) {
            let date = new Date(parseInt(value));
            let y = date.getFullYear();
            let MM = date.getMonth() + 1;
            MM = MM < 10 ? "0" + MM : MM;
            let d = date.getDate();
            d = d < 10 ? "0" + d : d;
            let h = date.getHours();
            h = h < 10 ? "0" + h : h;
            let m = date.getMinutes();
            m = m < 10 ? "0" + m : m;
            let s = date.getSeconds();
            s = s < 10 ? "0" + s : s;
            return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
        },
    },
    methods: {
        paynow(index) {
            let me = this,
                data = me.RecordData;
            let id = data[index];
            me.$router.push({
                name: "Paynow",
                params: {
                    orderdata: JSON.stringify(id),
                },
            });
        },
        async checkBoshInvoice(orderId) {
            let res = await this.$team.loadBoshInvoice({
                orderId: orderId,
            });
            if (res && res.success) {
                window.open(res.content.pictureUrl, "_blank");
            }
        },
        async cancel(index) {
            let me = this,
                data = me.RecordData;
            me.$confirm("确定取消该订单, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    let param = {};
                    param.orderId = data[index].order.id;
                    let res = await me.$userService.cancelOrder(param);
                    if (res && res["success"]) {
                        me.queryOrder();
                    }
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
        changeorders() {
            this.queryOrder();
        },
        // 处理每页显示数量
        handleSizeChange(page) {
            let me = this;
            me.orderForm.pageSize = page;
            me.getTerm();
        },
        //  当前页发生改变
        handleCurrentChange(page) {
            let me = this;
            me.orderForm.pageIndex = page;
            me.getTerm();
        },
        async queryOrder() {
            let me = this,
                param = me.orderForm;
            let res = await me.$userService.queryOrder(param);
            if (res && res["success"]) {
                res.content.records.forEach(function (item, index) {
                    item.agediscount = false;
                    item.isbm = false;
                    item.ismast = false;
                    item.isspecial = false;
                    item.isxx = false;
                    item.istransfer = false;
                    item.reductionFlag = false;
                    item.orderClassStudents.forEach(function (sitem, sindex) {
                        try {
                            const classRoomNames = sitem.classRoomNames.split(
                                ","
                            );
                            const periodName = sitem.periodName.split(",");
                            let customClassName = "";
                            classRoomNames.forEach((citem, index) => {
                                customClassName +=
                                    classRoomNames[index] +
                                    "：" +
                                    periodName[index] +
                                    (classRoomNames.length === index + 1
                                        ? ""
                                        : "；");
                            });
                            sitem.$customClassName = customClassName;
                        } catch (e) {
                            sitem.$customClassName = "";
                        }
                        if (sitem.zkAge && sitem.ageRemissionMoney) {
                            item.agediscount = true;
                        }
                        if (sitem.materialCost) {
                            item.ismast = true;
                        }
                        if (sitem.allClassFee) {
                            item.isbm = true;
                        }
                        if (sitem.identityRemission) {
                            item.isspecial = true;
                        }
                        if (sitem.traFee) {
                            item.transfer = true;
                        }
                        if (sitem.susFee) {
                            item.isxx = true;
                        }
                        if (sitem.reductionFlag) {
                            item.reductionFlag = true;
                        }
                        //  me.mainData.forEach(function(items,indexs){
                        //   if(sitem.classId==items.id){
                        //     sitem.isShortTraining= items.isShortTraining
                        //     sitem.shortTrainingEnd=items.shortTrainingEnd
                        //     sitem.shortTrainingStart=items.shortTrainingStart
                        //   }
                        // })
                    });
                });
                me.RecordData = res.content.records;
                if (me.RecordData.length > 0) {
                    me.showflag = false;
                } else {
                    me.showflag = true;
                }
                me.total = res.content.total;
            }
        },
        async getTerm() {
            const fullscreenLoading = this.$loading({
                lock: true,
                text: "页面数据加载中，请稍等...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            let me = this,
                param = {
                    type: "1",
                    planType: "1",
                };
            let res = await me.$userService.select(param);
            if (res && res["success"]) {
                me.orderForm.termId = res.content.term.id;
                me.queryOrder();
                fullscreenLoading.close();
            }
        },

        setIndex(e) {
            let me = this;
            me.tabindex = e.index;
        },
    },
};
</script>

<style lang="scss">
@import "../../assets/less/global.less";
@import "../../assets/css/icon.css";
@import "../../assets/css/app.css";
#student {
    .el-row {
        margin: 20px 0px;
    }
    .order-title {
        background: #f6f8fc;
        color: #535b6c;
        border: 1px solid #ebeef5;
        padding: 15px 0 15px 10px;
        font-size: 16px;
        border-bottom: none;
        margin-bottom: 30px;
    }

    .order-info {
        display: flex;
        justify-content: space-between;
        padding: 30px 30px;
        color: #535b6c;
        border: 1px solid #ebeef5;
        border-top: none;
        background: #fff;
        div {
            font-size: 16px;
            span.total {
                font-weight: bold;
                color: #ff8d3c;
            }
        }

        .f-footer {
            overflow: hidden;
            div {
                margin-bottom: 8px;
            }
            .el-button--default {
                color: #535b6c;
                border: 1px solid #e5eaf0;
            }
            div:not(:nth-child(1)) {
                margin: 20px 0;
            }
            div {
                span:first-child {
                    display: inline-block;
                    width: 160px;
                    text-align: right;
                    margin-right: 10px;
                }
            }
            div:nth-child(3) {
                span:last-child {
                    color: #ff8d3c;
                    font-weight: 700;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/orders/order.vue